// extracted by mini-css-extract-plugin
module.exports = {"container":"DX6kg","slide":"_2zQY9","postWrapper":"_3z0kE","withoutFooter":"D9JZR","separator":"TMOum"};